'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHidden = isHidden;

var _getBrowserPrefix = require('./getBrowserPrefix');

var _getHiddenNamespace = require('./getHiddenNamespace');

function isHidden() {
  var prefix = (0, _getBrowserPrefix.getBrowserPrefix)();
  if (prefix) {
    var hidden = (0, _getHiddenNamespace.getHiddenNamespace)(prefix);
    return document[hidden];
  }

  if (typeof document.hasFocus === 'function') {
    return !document.hasFocus();
  }

  return false;
}